import React,{useState,useEffect} from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Ajax from './Ajax';
import {Inc,Play,EventParam} from "./Inc";
import {Styles} from './Styles';
import Loading from './Loading';
import {Tools} from './Tools';
import FourMeters from './FourMeters';
import Parameter from './Parameter';

interface Props {
    play:Play,
    param:EventParam,
    close(play:Play):void,
    gold(num:number):void,
}

let selectedIndex = 0;

const EventDetox = (props:Props)=> {
    const classes = Styles.base();
    const [states,setStates] = useState({
        newPlay: Inc.defaultPlay(),
        selected: false,
        finished: false,
        isLoading: false,
    })
    const detox = (e: React.MouseEvent<HTMLElement>) =>{
        if( e.currentTarget.dataset.index ){
            selectedIndex = parseInt(e.currentTarget.dataset.index);
        } else {
            selectedIndex = 0;
        }
        setStates({...states,isLoading:true});
        Ajax.send("event/send",{play_id:props.play.id,selected:selectedIndex},(res:any)=>{
            if( res.ok ){
                if( selectedIndex===1 ){
                    props.gold(-1);
                }
                setStates({...states,newPlay:res.play,isLoading:false,selected:true});
            }
        })
    }
    const close = ()=>{
        props.close(states.newPlay);
    }
    const finish = ()=>{
        setStates({...states,finished:true});
    }

    useEffect( ()=>{
        selectedIndex = 0;
    },[]);

    if( states.selected ){
        return (
            <div id="event_bottles">
                <div className={classes.room}>
                {selectedIndex===0 ? (
                    <span>ホースを枕元に戻した<br/>青い機械から小さな舌打ちのような音がした</span>
                ):(
                    <span>ベッドに横たわり青い機械にコインを入れると、何かを吸ったのか吸わされたのかわからなかったけど胃の底が少し軽くなった</span>
                )}
                </div>
                <div className={classes.meters}>
                    <FourMeters stWater={props.play.water} stMagenta={props.play.magenta} stCyan={props.play.cyan} stYellow={props.play.yellow} enWater={states.newPlay.water} enMagenta={states.newPlay.magenta} enCyan={states.newPlay.cyan} enYellow={states.newPlay.yellow} finish={finish}/>
                </div>
                {states.finished &&
                <div className={classes.modalBottom}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={close}>{Tools.voice()}</Button>
                    </FormControl>
                </div>
                }
            </div>
        );    
    }

    return (
        <div id="event_bottles">
            <div className={classes.room}>
            ベッドの脇に青い機械がある<br/>
            活劇のようなフォントで「サニタイザア」と書かれていて、蛇腹のホースが枕元まで伸びている<br/>
            {props.param.selected===0 &&
                <div>{Tools.lover(props.play,props.param)}が使おうとして、やめたのかも知れない</div>
            }
            {props.param.selected===1 &&
                <div>{Tools.lover(props.play,props.param)}がこれを使ったのだろう<br/>ホースの先がほんのり湿っていた</div>
            }
            </div>
            <div className={classes.modalBottom}>
                <FormControl fullWidth={true} className={classes.formControl}>
                    <Button variant="outlined" color="primary" onClick={detox} data-index={1} style={{marginBottom:"0.2em"}} disabled={props.play.gold===0}>使う（コイン1枚）</Button>
                    <Button variant="outlined" color="primary" onClick={detox} data-index={0} style={{marginBottom:"0.2em"}}>使わない</Button>
                </FormControl>
                <Parameter play={props.play}/>
            </div>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default EventDetox;
